import Image from 'next/image'
import { useLocale } from 'next-intl'
import { Language, Locale, parseLanguageFromLocale } from '@/setup/locales'
import { cn } from '@/utils/styles/cn'

interface IPhoneScreenProps {
    getContentSrc: (language: Language) => string
    className?: string
}

export const PhoneScreen = ({ getContentSrc, className }: IPhoneScreenProps) => {
    const locale = useLocale()
    const rawWidth = 400
    const rawHeight = 802

    const ratio = 1.3

    const height = rawHeight * ratio
    const width = rawWidth * ratio

    const language = parseLanguageFromLocale(locale as Locale)

    return (
        <Image
            height={height}
            width={width}
            src={getContentSrc(language)}
            alt="iPhone content"
            priority
            className={cn('w-full h-auto ', className)}
            style={{
                aspectRatio: `${rawWidth}/${rawHeight}`,
            }}
        />
    )
}
